import type { RosterResponse, RosterSection } from '@clan-heart/shared';

/** One row of the Hall of Members' player grids. */
export interface PlayerRow {
  name: string;
  role?: string;
  img?: string;
}

/**
 * The Hall of Members on the public About page reads from GET /api/roster;
 * `roster` is `undefined` while that request is loading or after it has
 * failed (AboutPage passes `undefined` in both cases, not just on failure,
 * so the page never jumps from the hard-coded rows to live ones mid-load).
 * Either way this falls back to AboutPage's own hard-coded array, which it
 * keeps exactly as they are today — the one thing guaranteed to render
 * something even if the API never answers.
 */
export function rosterRowsFor(
  section: RosterSection,
  roster: RosterResponse | undefined,
  fallback: PlayerRow[],
): PlayerRow[] {
  if (!roster) return fallback;
  return roster.sections[section].map((entry) => ({
    name: entry.name,
    role: entry.subtitle || undefined,
    img: entry.flag,
  }));
}
